import { render } from "./fail.vue?vue&type=template&id=8c7cc34c&scoped=true"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"

import "./fail.vue?vue&type=style&index=0&id=8c7cc34c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7cc34c"]])

export default __exports__